import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation resources
import enTranslations from '../locales/en/translations.json';
import noTranslations from '../locales/no/translations.json';

i18n
  // Detect user language from localStorage or browser
  .use(LanguageDetector)
  // Pass i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Default language
    fallbackLng: 'no',
    
    // Languages we have translations for
    supportedLngs: ['en', 'no'],
    
    // Language detection configuration
    detection: {
      // Check localStorage first
      lookupLocalStorage: 'i18nextLng',
      // Order of detection strategies
      order: ['localStorage', 'navigator'],
      // Cache user language preference
      caches: ['localStorage'],
      // Convert detected language to our supported languages
      convertDetectedLanguage: (lng) => {
        if (lng.startsWith('no')) return 'no';
        if (lng.startsWith('en')) return 'en';
        return 'no'; // Default to Norwegian for all other languages
      }
    },

    // Resources with translations
    resources: {
      en: {
        translation: enTranslations
      },
      no: {
        translation: noTranslations
      }
    },

    // Configuration options
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Development/debugging options
    debug: false,
  });

export default i18n;

